module.exports = __webpack_public_path__ + "img/icon_list-03.0b528760.svg";